import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '../../core/config/api.config';
import {INSTITUTE_SERVICE} from '../../core/config/api.constants';
import {endpoint} from '../path.constants';
import {ApiResponse} from '../api-response.model';
import {EnumData, InstituteEnumData} from '../enum/enum.model';
import {Institute} from "../models/institute.model";
import {Programs} from "../models/program.model";


@Injectable({providedIn: 'root'})
export class InstitutesService {
    private readonly baseUrl = ApiConfig.getBaseUrl(INSTITUTE_SERVICE);
    private _instituteToken: string = "";

    constructor(private http: HttpClient) {
    }

    set setInstituteToken(value: string) {
        this._instituteToken = value;
    }

    getInstituteEnum() {
        const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        return this.http.get<ApiResponse<InstituteEnumData>>(
            this.baseUrl + endpoint.institute.enum, {headers}
        );
    }

    getInstituteDetail() {
        let headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        headers = headers.append('Institute-Token', this._instituteToken);

        return this.http.get<ApiResponse<Institute>>(
            this.baseUrl + endpoint.institute.detail, {headers}
        );
    }

    getInstitutePrograms() {
        let headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        headers = headers.append('Institute-Token', this._instituteToken);

        return this.http.get<ApiResponse<Programs>>(
            this.baseUrl + endpoint.institute.programs, {headers}
        );
    }
}
